// noinspection JSIgnoredPromiseFromCall

import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { assignVehicleToDevice } from '../../services/VehiclesService';
import { Device } from '../../types/Devices';
import { AssignVehicleToDeviceRequest } from '../../types/Vehicles';

type Result = UseMutationResult<Device, Error, AssignVehicleToDeviceRequest>;

function useAssignVehicleToDevice(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(assignVehicleToDevice, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['devices'] });
      queryClient.invalidateQueries({ queryKey: ['device'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useAssignVehicleToDevice;
